export default {
  nav: {
    bottomNav: {
      home: 'ホーム',
      record: '記録',
      calendar: '行事予定',
      vevo: 'VEVO',
      settings: '設定',
    },
  },
  vevo: {
    reportFallback: 'レポート',
    intro: {
      greeting: '保護者のみなさま',
      line1: 'こちらでは成長のようすとして',
      line2: 'お子さまの日々の姿を',
      line3: '3ヶ月に一度お届けします！',
    },
    listTitle: 'レポート一覧',
    empty: {
      line1: 'まだレポートが届いていません。',
      line2: '次のクォーターをお楽しみに！',
    },
    publishedAt: '{date} 公開',
    detail: {
      title: 'VEVOレポート',
      notFound: 'レポートが見つかりませんでした。',
      monthRange: '{start}月～{end}月',
      coverageNote: '{range}にデータがある場合に生成しています。',
      caution: '※この文章は、保育士が確認したお子さまの成長のようすをもとに作成されておりますが、AIによるデータの解釈の違いによって、間違った情報になる可能性があります。',
      language: '表示言語',
      languages: {
        en: 'English',
        ja: 'Japanese',
        km: 'Khmer',
        vi: 'Tiếng Việt',
        ko: 'Korean',
        zh: 'Chinese',
        hi: 'Hindi',
        ru: 'Russian',
        bn: 'Bengali',
        mn: 'Mongolian',
        tl: 'Tagalog',
        ms: 'Malay',
      },
    },
  },
  validation: {
    required: '必須入力項目です',
    choice2: '2つ選択してください',
    counter: '20文字以内で入力してください',
    counter2: '2文字で入力してください',
    counter3: '3文字で入力してください',
    counterMin4: '4文字以内で入力してください',
    counter14to16: '14〜16文字で入力してください',
    counter100: '100文字以内で入力してください',
    counter500: '500文字以内で入力してください',
    counter1000: '1000文字以内で入力してください',
    typeNumber: '数値で入力してください',
    typeStringNumber: '数値で入力してください',
    email: 'メールアドレスの形式で入力してください',
    phoneNumber: '電話番号の形式が違います',
    postalCode: '郵便番号の形式が違います',
    integerThan0: '0以上の整数で入力してください',
    multipleSelectRequired: '必須入力項目です',
    typeKana: 'カタカナで入力してください',
    typeKanaFullWidth: '全角カタカナで入力してください',
    typeHiraganaFullWidth: '全角ひらがなで入力してください',
    typeAlphabet: '半角英字で入力してください',
  },
  setting: {
    growth: '成長記録',
    invoice: '請求書',
    variousSettings: '各種設定',
    familySettings: '家族設定',
    paymentSettings: '支払設定',
    notificationSettings: '通知設定',
    languageSettings: '言語設定',
    logout: 'ログアウト',
  },
  settingLanguage: {
    title: '言語設定',
    save: '保存',
    successMessage: '言語設定を保存しました',
    languages: {
      english: 'English（英語）',
      khmer: 'ភាសាខ្មែរ（クメール語）',
      japanese: '日本語',
    },
  },
  invoice: {
    selectTitle: '請求書',
  },
  settingFamily: {
    title: '家族設定',
    guardians: '保護者',
    you: 'あなた',
    inviteGuardian: '他の保護者を招待する',
    children: 'お子さま',
    addChild: 'お子さまを追加する',
    familyInfo: '家族情報',
    parentType: {
      mother: '母',
      father: '父',
      grandma: '祖母',
      granpa: '祖父',
      uncle: '叔父',
      aunt: '叔母',
      sister: '姉妹',
      brother: '兄弟',
      other: 'その他',
    },
  },
  parentEdit: {
    save: '保存',
    lastName: '姓',
    firstName: '名',
    lastNameKana: 'せい',
    firstNameKana: 'めい',
    deleteAccount: 'この保護者アカウントを削除する',
    successMessage: '登録が完了しました',
    bloodType: {
      a: 'A型',
      b: 'B型',
      o: 'O型',
      ab: 'AB型',
      unknown: '不明',
    },
  },
  parentAdd: {
    title: '家族を招待',
    emailLabel: 'メールアドレス',
    parentTypeLabel: '保護者タイプ',
    noticeSignup: '※招待された方は、上記に入力したメールアドレスを使ってサインアップしていただく必要があります。',
    noticeSpam: '※招待メールが迷惑フォルダなどに振り分けられた場合であっても、サインアップ（新規登録）が可能です。',
    submit: '送信',
    invitedEmails: '招待済みメールアドレス',
    inviteSuccess: '招待が完了しました',
    parentType: {
      mother: '母',
      father: '父',
      grandma: '祖母',
      granpa: '祖父',
      uncle: '叔父',
      aunt: '叔母',
      other: 'その他',
    },
  },
  childEdit: {
    processing: '処理中です。しばらくお待ちください...',
    save: '保存',
    lastName: '姓',
    firstName: '名',
    lastNameKana: 'セイ',
    firstNameKana: 'メイ',
    successMessage: '保存が完了しました',
  },
  childrenGrowth: {
    save: '保存',
    successMessage: '登録が完了しました',
  },
  childAdd: {
    title: 'お子さま追加',
    childIdLabel: 'お子様のID',
    password: 'パスワード',
    submit: 'お子さまを追加する',
    successMessage: '登録が完了しました',
  },
  meCreate: {
    tapToChange: 'タップで変更',
    lastName: '姓',
    firstName: '名',
    lastNameKana: 'せい',
    firstNameKana: 'めい',
    birthDate: '生年月日',
    bloodType: '血液型',
    phoneNumber: '電話番号',
    submit: '送信',
  },
  familyCreate: {
    description: {
      line1: '本画面は、園児との初回登録時に表示される画面です。',
      line2: '過去にCCSHOMEをご利用いただいたことがある場合、初回登録時とは異なるメールアドレスでログインしようとしています。',
      line3: '一度ログアウトをタップし、初回登録時に使用したアカウント、ログイン方法でログインしてください。',
      line4: '初めて登録される方は、下記に案内状に記載のお子様IDおよびパスワードをご入力ください。',
    },
    childId: 'お子様のID',
    password: 'パスワード',
    parentType: '保護者タイプ',
    submit: '送信',
    logout: 'ログアウト',
  },
  familyEdit: {
    title: '家族情報変更',
    familyName: '家族名',
    save: '保存',
    successMessage: '登録が完了しました',
  },
  settingNotification: {
    title: '通知設定',
    save: '保存',
    successMessage: '登録が完了しました',
    options: {
      both: '両方',
      pushOnly: 'PUSHのみ',
      emailOnly: 'メールのみ',
      none: '通知なし',
    },
    notifications: {
      absentConfirmed: '欠席連絡',
      pickupConfirmed: '送迎変更',
      pickupConfirmedTitle: '送迎変更が確認されました！',
      chatReceived: 'チャット',
      chatReceivedTitle: '新しいメッセージが届きました！',
      growthUpdated: '成長記録の更新',
      invoiceSettled: '請求書発行',
      creditSettled: 'クレジットカードへの請求',
      creditFailed: 'クレジットカードへの請求失敗',
    },
  },
  growth: {
    memory: '記録',
    graph: 'グラフ',
    nendo: '年度',
    implementationMonth: '実施月',
    height: '身長',
    weight: '体重',
    noData: 'データがありません',
    show: '表示',
    remarks: '備考',
    close: '閉じる',
    percentileRange: 'パーセンタイル値 3% ~ 97%の範囲',
  },
  calendar: {
    prevMonth: '前の月',
    nextMonth: '次の月',
    dateFormat: '{month}月{day}日',
    dateFormatFull: '{year}年{month}月{day}日（{dayOfWeek}）',
    monthName: '{month}',
    defecation: {
      hard: '硬い',
      normal: '普通',
      soft: '軟らかい',
      diarrhea: '水様便（下痢）',
    },
  },
  home: {
    loadingReleaseInfo: 'リリース情報を読み込み中...',
    loadMore: 'もっと見る',
    newAnnouncement: '新着のお知らせがあります!',
    fabReleaseInfo: 'リリース情報',
    fabAbsence: '欠席連絡',
    fabPickup: '送迎変更',
    qrBarcodeHint: '※上記バーコードを専用端末にかざしてください',
  },
  common: {
    cancel: 'キャンセル',
    submit: '送信',
    delete: '削除',
    unknown: '不明',
  },
  emailSendModal: {
    title: 'メール送信先の確認',
    emailLabel: '宛先メールアドレス',
    notice: {
      line1: '※ 添付ファイルをメールにて送信します。',
      line2: '※ 送信先の間違いにご注意ください。',
    },
    cancel: 'キャンセル',
    submit: 'メール送信',
    success: 'メールを送信しました',
    errors: {
      unavailable: '恐れ入りますが、現在ご利用できません',
      emailRequired: 'メールアドレスが入力されていません',
    },
  },
  translationModal: {
    title: '言語を選択',
    cancel: 'キャンセル',
    submit: '翻訳',
    success: '翻訳が完了しました',
    failure: '翻訳に失敗しました',
  },
  accountDelete: {
    title: '注意！！',
    description: {
      line1: 'アカウントを削除すると、このアカウントではログインできなくなり、以下の情報が全て失われます。',
      line2: '※ MEMORUも同様にログインできなくなります。',
    },
    items: {
      records: '連絡帳の全ての記録',
      chat: 'チャット履歴',
      growth: '成長記録の全データ',
      invoices: '受信した全請求書',
      memoru: 'MEMORUの全データ',
    },
    continue: '続行する',
    reasonPrompt: '削除理由を入力してください。',
  },
  record: {
    menu: {
      chat: 'チャット',
      todayRecord: '今日の記録',
      references: 'お知らせ一覧/資料室',
      vevo: 'VEVOレポート',
    },
    date: {
      yearSuffix: '{year}年',
      month: '{month}月',
      monthDay: '{month}月{day}日',
      prevDay: '前の日',
      nextDay: '次の日',
      prevMonth: '前の月',
      nextMonth: '次の月',
      editedAt: '（編集 {time}）',
    },
    section: {
      nurseryRecord: '園での記録',
      homeRecord: '家庭での記録',
      attendance: '登降園時間',
      sleep: '睡眠時間',
      meal: '喫食',
      mealComment: 'コメント',
      defecation: '排便',
      milk: 'ミルク',
      temperature: '体温',
      breakfast: '朝食',
      dinner: '夕食',
      childRecord: 'お子様の記録',
    },
    meal: {
      stapleFood: '主食',
      mainDish: '主菜',
      sideDish: '副菜',
      soup: '汁物',
      dessert: 'デザート',
      milk: '牛乳',
      snack: 'おやつ',
      commentPlaceholder: 'コメントを入力',
      actions: {
        finishAll: 'すべて完食',
        addRecord: '+記録を追加',
      },
    },
    action: {
      addSleep: '睡眠記録を追加',
      addTemperature: '体温記録を追加',
      addBreakfast: '朝食記録を追加',
      addDinner: '夕食記録を追加',
      addMilk: 'ミルク記録を追加',
      addDefecation: '排便記録を追加',
      saveDraft: '下書き保存',
    },
    status: {
      milkFormula: 'ミルク',
      milkBreast: '母乳',
      defecationHard: '硬い',
      defecationNormal: '普通',
      defecationSoft: '軟らかい',
      defecationDiarrhea: '水様便（下痢）',
      mealRefill: 'おかわり',
      mealFinished: '完食',
      mealUnfinished: '少し残した',
      mealHalf: '半分食べた',
      mealLittle: '少し食べた',
      mealNotEat: '食べなかった',
      mealNotServed: '未提供',
    },
    modal: {
      sleepTitle: '睡眠時間',
      sleepStart: '開始',
      sleepEnd: '終了',
      breakfastTitle: '朝食',
      dinnerTitle: '夕食',
      milkTitle: 'ミルク',
      milkTime: '時間',
      milkType: '種類',
      milkAmount: '量',
      defecationTitle: '排便',
      defecationTime: '時間',
      defecationState: '状態',
      temperatureTitle: '体温',
      temperatureTime: '時間',
      temperatureValue: '体温',
    },
    confirm: {
      deleteRecord: '記録を削除しますか?',
    },
    toast: {
      deleted: '削除が完了しました',
      updated: '変更が完了しました',
    },
  },
  references: {
    datePicker: {
      title: '年月を選択',
      year: '年',
      month: '月',
      apply: '決定',
    },
    detail: {
      date: '日付',
      title: 'タイトル',
      body: '本文',
      attachments: '添付ファイル',
      view: '表示する',
      iframeNotSupported: 'お使いのブラウザは iframe に対応していません。',
      downloadPdf: 'PDF をダウンロード',
      close: '閉じる',
    },
  },
  chat: {
    header: {
      record: '記録',
      prevDay: '前の日',
      nextDay: '次の日',
      year: '{year}年',
    },
    tabs: {
      chat: 'チャット',
      absence: '欠席連絡',
      pickup: '送迎変更',
    },
    menu: {
      delete: '削除',
      copy: 'コピー',
    },
    message: {
      read: '既読',
      groupChatLabel: '【連絡メール】\n',
      showAttachment: '添付ファイルを表示する',
      sendAttachmentByEmail: '添付ファイルをメールで送信する',
    },
    input: {
      send: '送信',
    },
    absence: {
      title: '欠席',
      reasons: {
        fever: '発熱',
        personal: '家庭の事情',
        infection: '感染症',
        others: 'その他',
        othersWithComment: 'その他（コメントの入力が必要）',
        infStrep: '溶連菌感染症',
        infMycoplasma: 'マイコプラズマ肺炎',
        infHFMD: '手足口病',
        infSlappedCheek: '伝染性紅斑（りんご病）',
        infStomach: 'ウイルス性胃腸炎（ノロ、ロタ、アデノ等）',
        infHerpangina: 'ヘルパンギーナ',
        infRS: 'RSウィルス感染症',
        infZoster: '帯状疱疹',
        infRoseola: '突発性発しん',
        infImpetigo: '伝染性膿痂疹（とびひ）',
        covid19: '新型コロナウィルス',
      },
    },
    absenceModal: {
      title: '欠席連絡',
      fields: {
        period: '期間',
        reason: '理由',
        detail: '詳細',
        comment: 'コメント',
      },
      actions: {
        ok: 'OK',
      },
      reasons: {
        fever: '発熱',
        personal: '家庭の事情',
        infection: '感染症',
        others: 'その他（コメントの入力が必要）',
      },
      infections: {
        infStrep: '溶連菌感染症',
        infMycoplasma: 'マイコプラズマ肺炎',
        infHFMD: '手足口病',
        infSlappedCheek: '伝染性紅斑（りんご病）',
        infStomach: 'ウイルス性胃腸炎（ノロ、ロタ、アデノ等）',
        infHerpangina: 'ヘルパンギーナ',
        infRS: 'RSウィルス感染症',
        infZoster: '帯状疱疹',
        infRoseola: '突発性発しん',
        infImpetigo: '伝染性膿痂疹（とびひ）',
        covid19: '新型コロナウィルス',
      },
    },
    pickup: {
      title: '送迎変更',
      dropOffBy: '登園送迎者：',
      dropOffTime: '登園時刻：',
      pickupBy: '降園送迎者：',
      pickupTime: '降園時刻：',
    },
    pickupModal: {
      title: '送迎変更',
      tabs: {
        dropOff: '登園',
        pickup: '降園',
      },
      fields: {
        date: '日付',
        dropOffBy: '登園の送迎者',
        dropOffTime: '登園時間',
        pickupBy: '降園の送迎者',
        pickupTime: '降園時間',
        reason: '理由',
      },
      parentRelation: {
        Mother: '母',
        Father: '父',
        Grandmother: '祖母',
        Grandfather: '祖父',
        Uncle: '叔父',
        Aunt: '叔母',
        Sister: '姉',
        Brother: '兄',
        Other: 'その他',
      },
    },
    action: {
      cancel: '取消',
      close: '閉じる',
      cancelBtn: 'キャンセル',
    },
    confirm: {
      deleteTitle: '削除しますか？',
    },
    toast: {
      copied: 'コピーしました',
      deleteCompleted: '削除が完了しました',
    },
  },
  noEmailVerified: {
    title: '本人確認用の認証メールを送信しました。',
    description: '以下の手順でログインしてください。',
    step1: 'メール内の「アカウントを確認」をタップして、Chromeブラウザを開く。',
    step2: '表示されるメッセージで「許可する」をタップする。',
    step3: 'CCS HOMEアプリを開き、お子様のIDとパスワード登録画面が表示される。',
    step4: '登録を進める。',
    noEmailTitle: '【メールが届かない場合】',
    noEmailDescription: '迷惑メールフォルダなどに自動で振り分けられてないかご確認ください。',
    loginButton: 'ログイン',
    reLoginButton: '別のアカウントで再度ログイン',
  },
  error: {
    default: 'システムに予期せぬエラーが発生しました。しばらく時間をおいてアクセス师德るかカスタマーサポートにお問い合わせください。',
    invalidParams: 'API仕様書で指定されているのとパラメータが違います。',
    tokenExpired: 'トークンが失効しています。',
    userNotFound: 'ユーザーが存在しません',
    userAlreadyExists: 'ユーザーが既に存在しています。',
    invalidObjectType: '指定されたObjectTypeが不正です。',
    breakfastNotFound: '朝食の記録が存在しません。',
    breakfastAlreadyExists: '朝食の記録が既に存在します。',
    dinnerNotFound: '夕食の記録が存在しません。',
    dinnerAlreadyExists: '夕食の記録が既に存在します。',
    bowelMovementNotFound: '排便の記録が存在しません。',
    milkNotFound: 'ミルクの記録が存在しません。',
    sleepNotFound: '睡眠の記録が存在しません。',
    temperatureNotFound: '体温の記録が存在しません。',
    childcareJournalNotFound: '保育日誌の記録が存在しません。',
    childcareJournalAlreadyExists: '保育日誌の記録が既に存在します。',
    eatingRecordNotFound: '喫食の記録が存在しません。',
    eatingRecordAlreadyExists: '喫食の記録が既に存在します。',
    absenceOverlap: '欠席期間に重複があるため登録できません。',
    invalidReason: '選択された理由が不正です。',
    invalidPickedUpPerson: '選択された送迎者が不正です。',
    messageNotFound: 'メッセージが見つかりません。',
    pickupDataNotFound: '送迎のデータが見つかりません。',
    classNotFound: 'クラスが見つかりません。',
    childNotFound: '指定の園児が見つかりません。お子様のID・パスワードを確認し、再度入力をお願いします。',
    childAlreadyRegistered: '指定した園児は既に自分の家族として登録されています。',
    familyNotFound: '指定した家族が見つかりません。',
    userNotInFamily: 'ユーザーが指定された家族に所属していません。',
    userAlreadyInvited: '指定されたユーザーは既に指定された家族に招待されています',
    formatNotFound: '指定のフォーマットが見つかりません',
    childIdNotSpecified: '園児IDが指定されていません',
    feedInfoNotFound: '指定されたフィード情報が存在しません。',
    feedDetailNotFound: '指定されたフィードの詳細情報が存在しません。',
    reportNotOwned: '指定されたレポートはユーザーのものではありません。',
    arrivalDepartureAlreadyExists: '指定された日付の登園・降園の記録が既に存在します。',
    arrivalDepartureNotFound: '登園・降園の記録が存在しません。',
    arrivalRecordNotFound: '指定された日付の登園記録がありません。',
    arrivalRecordAlreadyExists: '指定された日付の登園記録が既に存在します。',
    departureRecordAlreadyExists: '指定された日付の降園記録が既に存在します。',
    arrivalDepartureNotOwned: '指定された登園・降園の記録はこの園児のものではありません。',
    invalidNursery: '不正な保育園が指定されました。',
    hiraganaCheckFailed: '平仮名の判定に失敗しました。恐れ入りますがお問い合わせください。',
    invalidInternalId: '内部的に使用されているIDが不正です。',
    invalidUqid: 'uqidが不正です。',
    invalidChecksum: 'CheckSumが不正です。',
    userNotInNursery: 'ユーザーは指定した保育園に所属していません。',
    adminOnly: '管理者ユーザーのみが許可された操作です。',
    invalidApprovalStatus: '日誌の承認ステータスが不正です。',
    nurseryDiaryNotFound: '園日誌の記録が存在しません。',
    menuNotOwned: '指定した献立は指定した保育園の物ではありません。',
    userNotInNursery2: 'ユーザーは指定した保育園に所属していません。',
    adminOnly2: '管理者ユーザーのみが許可された操作です。',
    invalidApprovalStatus2: '日誌の承認ステータスが不正です。',
    nurseryDiaryNotFound2: '園日誌の記録が存在しません。',
    noApprovalPermission: 'このユーザーには承認権限がありません。',
    applicantMismatch: 'この日誌の申請者はこのユーザーではありません。',
    journalNotPending: 'この日誌は申請中ではありません。',
    alreadyApproved: '同一の権限で、他のユーザーが既に承認しています。',
    initialJournalStatus: '日誌の初回作成時の状態は、申請・下書きのいずれかである必要があります。',
    photoRecordNotFound: 'おたよりの記録が存在しません。',
    userNotInNursery3: 'このユーザーは指定した献立の保育園に所属していません。',
    foodInspectionAlreadyExists: '指定した献立に対する検食記録は既に存在しています。',
    foodInspectionNotFound: '指定された検食記録は存在しません。',
    annualEventNotFound: '指定した年間行事は存在しません。',
    classIdNotOwned: '指定したクラスIDは指定した保育園の物ではありません。',
    invalidSocketId: 'socketIdの形式が不正です。恐れ入りますがシステム管理者にお問い合わせください。',
    napCheckPatternNotFound: '午睡チェックパターンが存在しません。',
    duplicateStaff: '担当スタッフが重複しています。',
    staffNotInNursery: '指定したスタッフは指定した保育園に所属していません。',
    napPatternNotOwned: 'この午睡チェックパターンはこの園のものではありません。',
    childNotInNursery: 'この園児はこの保育園に所属していません。',
    napCheckNotFound: '午睡チェックが存在しません。',
    napCheckNotOwned: 'この午睡チェックはこの園のものではありません。',
    napCheckTempHumidityNotFound: 'この午睡チェックの温度・湿度データが存在しません。',
    napCheckNotPending: 'この午睡チェック記録は申請中ではありません。',
    childAlreadyInNapCheck: 'すでにこの午睡チェック記録に存在する園児は指定できません。',
    childNotInNapCheck: 'この午睡チェック記録に存在しない園児は指定できません。',
    staffAlreadyInNapCheck: 'すでにこの午睡チェック記録に存在するスタッフは指定できません。',
    napCheckCannotEdit: '終了もしくは申請中の状態の午睡チェック記録は編集できません。',
    napCheckDetailNotFound: '指定した午睡チェックの個別記録は存在しません。',
    napCheckDetailNotOwned: '指定した午睡チェックの個別記録はこの園のものではありません。',
    napCheckDetailAlreadyExists: '指定した午睡チェックの個別記録は既に存在しています。',
    childNotInNapCheck2: '指定した午睡チェックに指定した児童は含まれておりません。',
    invalidEventTime: '行事の時間指定が不正です。',
    noRelation: 'リレーションがありません。',
    napSensorNotFound: '午睡センサーが存在しません。',
    commentLimit: 'コメントは1000文字までで入力してください。',
    absenceConfirmationFailed: '欠席連絡の確認に失敗しました。',
    pickupChangeConfirmationFailed: '送迎変更の確認に失敗しました。',
    invalidEventPeriod: '行事の期間指定が不正です。',
    guardianNotFound: '保護者が見つかりません。',
    duplicateAllergyFood: '同名のアレルギー食品が既に登録されています。',
    allergyFoodNotOwned: '指定したアレルギー食品は指定した保育園の物ではありません。',
    staffAccountTitleExists: 'スタッフアカウント役職名がすでに存在しています。',
    staffAccountTitleNotFound: 'スタッフアカウント役職が存在しません。',
    staffAccountInfoExists: 'スタッフアカウント情報がすでに存在しています。',
    staffAccountInfoNotFound: 'スタッフアカウント情報が存在しません。',
    staffTitleInUse: 'このスタッフアカウント役職は現在使用されているため、削除できません。',
    endDateBeforeStartDate: '開始日が終了日より後に設定されています。',
    pastDateTime: '指定された日時は過去の日付です。',
    excelGenerationFailed: 'Excelファイルの生成に失敗しました。恐れ入りますが、システム管理者にお問い合わせください。',
    napSensorNotStarted: '午睡センサーが起動されていません。',
    napSensorRecordNotFound: '午睡センサーの記録が見つかりません。',
    absenceRegistrationNotFound: '欠席登録が見つかりません。',
    chatReadOnly: '他人が作成したチャットは閲覧のみ可能です。',
    emailInUse: 'ご指定のメールアドレスは他のユーザーに利用されているため変更できません。',
    attachmentNotFound: '添付ファイルが見つかりません。',
    certificationNotFound: '認定・保育料の記録が存在しません。',
    certificationEndDateRequired: '認定期間の終了日を入力してください。',
    certificationPeriodOverlap: '認定・保育料の期間指定が不正です。他の期間との重複がないか確認してください。',
    accountTitleNotFound: '対象の勘定科目が見つかりません。',
    accountTitleInUse: '勘定科目が小口現金出納帳で利用されているため削除できません。',
    pettyCashDetailNotFound: '小口現金出納帳の詳細レコードが見つかりません。',
    duplicateAllergyItem: '同名のアレルギー項目がすでに登録されています。',
    allergyItemNotFound: 'アレルギー項目が見つかりません。',
    allergyItemCannotModify: '指定されたアレルギー項目は削除・更新することができません。',
    menuTypeNotFound: '献立種別が見つかりません。',
    menuNotFound: '献立が見つかりません。',
    foodInspectionNotFound2: '検食が見つかりません。',
    foodInspectionAlreadyCreated: '検食がすでに作成済みです。',
    extendedCarePatternNotFound: '延長保育パターンが見つかりません。',
    timeSlotOverlap: '時間枠に被りがあるため保存できません。',
    timeSlotNotFound: '時間枠が見つかりません。',
    timeStampSettingNotFound: '打刻設定が存在しません。',
    extendedCareDiaryNotOwned: '指定した延長保育日誌は指定した保育園のものではありません。',
    nurseryServiceNotRegistered: '指定した園提供サービスはマスターに登録されていません。',
    nurseryServiceAlreadyRegistered: '指定した園提供サービスは既に登録されています。',
    nurseryServiceNotEnrolled: '指定した園提供サービスは利用登録されていません。',
    monthlyServiceSetDate: '月額制の施設提供サービスの場合は、1日 日付を利用日として設定してください。',
    nurseryServiceInUse: '指定した施設提供サービスは利用されているため削除できません。',
    invalidServiceType: '施設提供サービスのserviceTypeの形式が不正です。',
    invalidPaymentMonthType: '施設提供サービスのpaymentMonthTypeの形式が不正です。',
    invalidAccountType: '施設提供サービスのaccountTypeの形式が不正です。',
    userNotInManagementCompany: 'ユーザーは指定した運営企業に所属していません。',
    managementCompanyNotFound: '運営会社が見つかりません。',
    invoiceNotFound: '指定された請求書が存在しません。',
    invalidInvoiceStatus: '請求書のステータスが不正です。',
    invoiceNotConfirmed: '請求書がまだ確定されていません。',
    fileReadFailed: 'ファイルの読み込みに失敗しました。CSVファイルの形式を確認してください。',
    invalidChildCode: 'CSVファイルの園児コードが不正です。',
    invalidReceivableValue: 'CSVファイルの売掛金の値が不正です。',
    receivableImportNotFound: '売掛金残高のインポート状況が存在しません。',
    salesInfoSentCannotEdit: 'この月の売上情報が送信されているため, この登園・降園記録は編集できません。',
    pettyCashConfirmedCannotChange: '確定ステータスの小口現金出納帳は変更できません。',
    salesConfirmedCannotEdit: 'この月の売上情報が確定しているため, 対象期間を含む保育料・認定情報は編集できません。',
    otherServiceDetailNotFound: '指定されたその他サービス詳細が存在しません。',
    childWithoutCertification: '保育料・認定情報が登録されていない園児がいます。設定してから送信してください。',
    managementCompanyServiceNotFound: '運営企業のサービス設定が存在しません。',
    insufficientPermission: '権限不足のため小口現金出納帳の確定ステータスを解除することができません。',
    notDraftStatus: '下書きステータスではないため操作することができません。',
    salesConfirmedCannotEdit2: 'この月の売上情報が確定しているため, 対象期間を含む園提供サービスは編集できません。',
    nurseryAccountNotFound: '園の振込口座の設定が見つかりません。',
    childAlreadyWithdrawn: '既に退園済みの園児です。',
    discussionNotFound: '指定のディスカッションが見つかりません。',
    invalidGmoCardToken: 'GMOのカードのトークンが不正です。',
    cardRegistrationFailed: 'カード登録でエラーが発生しました。カード情報をご確認ください。',
    gmoCardNotFound: 'GMOのカード情報が見つかりません。',
    gmoCardDeleteFailed: 'GMOのカード削除でエラーが発生しました。',
    fileTooLarge: '10MBを超えるためファイルは送信できません。',
    emailNotVerified: 'Eメール認証がされていません。\nEメールを確認してください。',
    internalServerError: 'Internal Server Error',
    noDetailedErrorMessage: '詳細なエラーメッセージがありません',
    emailNotAvailable: 'このメールアドレスは使用できません',
  },
};
